/**
 * EmailJS Configuration
 * 
 * To set up EmailJS:
 * 1. Go to https://www.emailjs.com/
 * 2. Create an account and verify your email
 * 3. Create a new service (Gmail, Outlook, etc.)
 * 4. Create an email template
 * 5. Get your Service ID, Template ID, and Public Key
 * 6. Replace the values below with your actual credentials
 */

export const emailJSConfig = {
  // Replace with your EmailJS Service ID
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'your_service_id',
  
  // Replace with your EmailJS Template ID
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'your_template_id',
  
  // Replace with your EmailJS Public Key
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'your_public_key',
  
  // Admin email where loan applications will be sent
  adminEmail: process.env.REACT_APP_ADMIN_EMAIL || 'admin@orbitfinancialservices.com'
};

// Debug logging (remove in production)
console.log('Environment Variables Debug:');
console.log('REACT_APP_EMAILJS_SERVICE_ID:', process.env.REACT_APP_EMAILJS_SERVICE_ID);
console.log('REACT_APP_EMAILJS_TEMPLATE_ID:', process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
console.log('REACT_APP_EMAILJS_PUBLIC_KEY:', process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
console.log('REACT_APP_ADMIN_EMAIL:', process.env.REACT_APP_ADMIN_EMAIL);
console.log('Resolved emailJSConfig:', emailJSConfig);

// Template for EmailJS email template
export const emailTemplate = `
Subject: New Loan Application - {{full_name}}

Dear Orbit Financial Services Team,

A new loan application has been submitted through the website.

SUBMISSION DETAILS:
Date: {{submission_date}}
Time: {{submission_time}}

APPLICANT INFORMATION:
Name: {{full_name}}
Email: {{email}}
Phone: {{phone_number}}
Address: {{address}}
Applicant Type: {{applicant_type}}

EMPLOYMENT/BUSINESS DETAILS:
{{#if employment_category}}
Employment Category: {{employment_category}}
{{/if}}
Employer/Business Name: {{business_name}}
{{#if business_nature}}
Business Nature: {{business_nature}}
{{/if}}
{{#if other_business_nature}}
Other Business Nature: {{other_business_nature}}
{{/if}}
Years in Operation/Employment: {{years_in_operation}}
Monthly Income/Revenue: {{monthly_income}}

{{#if date_of_birth}}
PERSONAL INFORMATION:
Date of Birth: {{date_of_birth}}
{{/if}}

LOAN DETAILS:
Amount Requested: {{loan_amount}}
Purpose: {{loan_purpose}}
{{#if other_purpose}}
Other Purpose: {{other_purpose}}
{{/if}}
Repayment Duration: {{repayment_duration}}

EXISTING LOANS:
Has Existing Loans: {{existing_loans}}
{{#if servicing_loans}}
Currently Servicing: {{servicing_loans}}
{{/if}}
{{#if total_borrowing}}
Total Borrowing: {{total_borrowing}}
{{/if}}
{{#if borrowing_date}}
Borrowing Date: {{borrowing_date}}
{{/if}}
{{#if current_exposure}}
Current Exposure: {{current_exposure}}
{{/if}}
{{#if lending_institutions}}
Lending Institutions: {{lending_institutions}}
{{/if}}
{{#if bvn}}
BVN: {{bvn}}
{{/if}}

{{#if has_invoices}}
BUSINESS INFORMATION:
Has Invoices/Contracts: {{has_invoices}}
{{/if}}

CONTACT PREFERENCES:
Preferred Contact Method: {{preferred_contact_method}}
Consent Given: {{consent}}

Please review this application and contact the applicant using their preferred method.

Best regards,
Orbit Financial Services Website
`;
